// extracted by mini-css-extract-plugin
export default {"gearMenu":"UserManagement_gearMenu__xvmnq","cardWrapper":"UserManagement_cardWrapper__Xttpn","userDetails":"UserManagement_userDetails__Dtqqf"};